import FullWidthLayout from "@/layouts/FullWidthLayout";
import SealantCalculator from "kinnect-front/Apps/SealantCalculator";
import { Pageable } from "kinnect-mixins";

export default {
	name: "SealantCalculatorPage",

	metaInfo: { title: "Apps - Sealant Calculator" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<SealantCalculator></SealantCalculator>
		</FullWidthLayout>;
	}
};
